
const randomNumber = (max) => {
    const precision = 100; // 2 decimals
    let randomnum = Math.floor(Math.random() * (max * precision - 1 * precision) + 1 * precision) / (1*precision);
    return randomnum
}

export default randomNumber